import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue') // Lazy-loaded
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('../views/Shop.vue') // Lazy-loaded
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue') // Lazy-loaded
  },
  {
    path: '/zipper',
    name: 'Zipper',
    component: () => import('../views/Zipper.vue') // Lazy-loaded
  },
  {
    path: '/product/:handle',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue') // Lazy-loaded
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/Cart.vue') // Lazy-loaded
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;